import { cn } from "utils";
import { InfoTooltip } from "components/InfoTooltip";
import { Text, type TextProps } from "components/text";
import { ListItem } from "components/List/ListItem";
import { SelectToggleIcon } from "components/SelectToggleIcon";
import { TruncatedText } from "components/TruncatedText";

interface SelectableListItemProps {
  id: string;
  text: string;
  subtext?: string;
  isSelected: boolean;
  testId: string;
  onSelect: () => void;
  infoText?: string;
  className?: string;
  textClassName?: string;
  subtextVariant?: TextProps["variant"];
}

export const SelectableListItem = ({
  id,
  text,
  subtext,
  isSelected,
  testId,
  onSelect,
  infoText,
  className,
  textClassName,
  subtextVariant = "subtle",
}: SelectableListItemProps) => {
  return (
    <ListItem
      onClick={onSelect}
      testId={testId}
      className={className}
      aria-selected={isSelected}
    >
      <div className="flex flex-row gap-x-2 min-w-0 flex-1">
        <TruncatedText
          text={text}
          className={cn("text-sm text-secondary-900", textClassName)}
        />
        {subtext && (
          <div className="flex items-center min-w-0 flex-1">
            <Text variant={subtextVariant} className="truncate">
              {subtext}
            </Text>
          </div>
        )}
        {infoText && (
          <InfoTooltip
            text={infoText}
            testId={`info-icon-${id}`}
            visibilityMode="onParentHover"
          />
        )}
      </div>

      <span className="shrink-0 ml-2">
        <SelectToggleIcon selected={isSelected} id={id} size="medium" />
      </span>
    </ListItem>
  );
};
